import { createFileRoute, redirect } from "@tanstack/react-router";

/** Landing URL — send authenticated users to dashboard, others to the marketing home page. */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") {
      throw redirect({ to: "/home" });
    }

    const sb = context.supabase;
    if (sb) {
      const {
        data: { session },
      } = await sb.auth.getSession();
      if (session) {
        throw redirect({ to: "/dashboard" });
      }
    }

    throw redirect({ to: "/home" });
  },
});
